import React from 'react';

const LOL = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1690_72606)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.91998 0.900024L3.63671 3.67415V12.8078L1.80703 15.5925H12.533L15.3425 11.9194H7.94528V0.900024H1.91998ZM4.12248 2.12455H6.71433V13.1439H12.8585L11.9233 14.3685H4.08253L4.86767 13.1738V3.32842L4.7763 3.18149L4.12248 2.12455ZM9.1767 2.24163V3.49096C11.64 4.04973 13.4853 6.24121 13.4853 8.85831C13.4853 9.50248 13.3723 10.12 13.1666 10.6949H14.4577C14.6244 10.1108 14.7162 9.49514 14.7162 8.85831C14.7162 5.56352 12.3232 2.81923 9.1767 2.24163ZM2.40575 4.99877C1.78591 5.87619 1.36901 6.90375 1.2276 8.0167C1.1927 8.29219 1.1748 8.57318 1.1748 8.85831C1.1748 9.20175 1.20051 9.53922 1.25056 9.86888C1.41125 10.9171 1.81759 11.8854 2.40575 12.7183V4.99877Z",
      fill: "#B3B3B3"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1690_72606" }, /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: "14.6925",
      height: "14.6925",
      fill: "white",
      transform: "translate(0.650002 0.900024)"
    }
  )))
);
LOL.displayName = "Icons.LOL";

export { LOL };
//# sourceMappingURL=LOL.js.map
